<template>
  <div class="scp-table">
    <div class="subtitle">
      <span class="statistics-date">省区：{{zone}} - {{province}}</span>

      <div class="sc-table-header-right">
        <div
          class="update-date"
          v-if="latestUpdateDate"
        >最近更新时间：{{util.toDateString(latestUpdateDate)}}</div>
        <div class="tips">
          <img src="@/assets/？.png" />
          <span>统计方式是月至今，即月初到更新日期内供应数据</span>
        </div>
      </div>
    </div>

    <el-table
      v-loading="loading"
      :data="retrieve.results"
      stripe
      header-cell-class-name="my-header-cell"
      header-row-class-name="my-header-row"
      row-class-name="my-row"
      cell-class-name="my-cell"
    >
      <el-table-column prop="code" label="供应商编码" width="80"></el-table-column>
      <el-table-column prop="name" label="供应商名称" width="150"></el-table-column>
      <el-table-column prop="quantity" label="供货量（单位）" width="110">
        <template slot-scope="scope">
          <span>{{util.formatMoney(scope.row.quantity, 2, '')}} {{scope.row.unit}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="进货额（元）" width="110">
        <template slot-scope="scope">
          <span>{{util.formatMoney(scope.row.amount, 2, '￥')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="amountRate" label="进货额占比">
        <template slot-scope="scope">
          <!-- <el-progress :percentage="scope.row.amountRate * 100"></el-progress> -->
          <span>{{util.formatMoney(scope.row.amountRate * 100, 2, '')}}%</span>
        </template>
      </el-table-column>
      <el-table-column prop="purchasePrice" label="移动平均进价" width="100">
        <template slot-scope="scope">
          <span>{{util.formatMoney(scope.row.purchasePrice, 2, '￥')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="地址" width="150"></el-table-column>
      <el-table-column prop="contact" label="联系人" width="80"></el-table-column>
      <el-table-column prop="introducer" label="采购引进人" width="80"></el-table-column>
    </el-table>

    <el-pagination
      background
      layout="prev, pager, next"
      :total="retrieve.page.totalCount"
      :page-size="retrieve.page.numPerPage"
      :current-page="retrieve.page.pageNum"
      @current-change="onCurrentChange"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "SupplyChainProvinceSupplierRanking",
  props: ["zone", "province"],
  data() {
    return {
      loading: true,
      date: "",
      latestUpdateDate: undefined
    };
  },
  computed: {
    retrieve() {
      const data = this.$store.state.sc.scSupplierProvince.latest;
      if (!data) {
        this.loading = false;
        return {
          page: {
            totalCount: 0,
            numPerPage: 10,
            pageNum: 1
          },
          results: []
        };
      }
      if (data.results.length > 0) {
        this.loading = false;
        if (!this.latestUpdateDate) {
          this.latestUpdateDate = new Date(data.results[0].saleDate);
        }
      }
      return data;
    }
  },
  methods: {
    onCurrentChange(e) {
      this.$emit("change", e);
    }
  }
};
</script>

<style lang="less">
.sc-table {
  .my-header-cell {
    background: #94a49b;
    color: white;

    font-size: 12px;
    padding: 0;
    height: 40px;
  }
  .my-row {
    // height: 40px;
  }
  .my-cell {
    padding: 0;
    height: 40px;
    font-size: 12px;
  }
  .el-range-editor.el-input__inner {
    padding: 0 10px;
  }
  .el-button {
    padding: 9px 20px;
  }
  .el-button--primary {
    background-color: #1b994f;
    border-color: #1b994f;
  }
  .el-pagination {
    text-align: center;
    margin: 20px 0;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #1b994f;
    border-color: #1b994f;
  }
}
</style>


<style lang="less" scoped>
.scp-table {
  // width: 900px;

  .title {
    margin: 20px 0;
    img {
      display: inline-block;
      width: 12px;
      height: 12px;

      margin-right: 10px;
    }
    div {
      display: inline-block;
      width: 80px;
      height: 28px;
      font-size: 20px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
    }
  }

  .subtitle {
    // padding: 10px 0;
    height: 45px;
    .statistics-date {
      width: 56px;
      height: 22px;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 22px;

      margin: 10px;
    }
    .button {
      margin-left: 10px;
    }
  }
}
</style>
